import { ESuburbanOfferFilter } from '@cian/api-models/common/json_query';
import { Action } from 'redux';

import { TThunkAction } from '../../types/redux';
import { FILTERS_SET_POSESSOR_TYPE } from '../../constants/action_types';
import { getMeta } from './getMeta';

export type TSetPosessorType = 'filters/set_posessor';

export interface ISetPosessor extends Action<TSetPosessorType> {
  type: TSetPosessorType;
  posessor: ESuburbanOfferFilter;
}

export type TSetPosessor = ISetPosessor;

export function setPosessor(posessor: ESuburbanOfferFilter): TThunkAction {
  return dispatch => {
    dispatch<TSetPosessor>({
      type: FILTERS_SET_POSESSOR_TYPE,
      posessor,
    });

    dispatch(getMeta());
  };
}
